
<template>

  <div v-if = "isAuthenticated" class="floating-button--container">
    <!-- START 11/12/2023 DISABLED OLEH SYAHRUL: sebab dalam chat masih ada error dan akan fix -->
    <!-- <button class="floating-button" @click="toggleComponent">
      <i v-if="showChatBox" class="fa fa-close icon" ></i>
      <i v-else class="fa fa-comments icon" ></i>
    </button> -->
    <!-- END 11/12/2023 DISABLED OLEH SYAHRUL: sebab dalam chat masih ada error dan akan fix -->
    <transition name="slow">
      <div class="chat-window" v-if="showChatBox">
        <component :is="chatWindow" />
      </div>
      <!-- <div v-if="showChatBox && !isAuthenticated">
        <component :is="login" />
      </div> -->
    </transition>
  </div>
  
</template>

<script>

import { mapState, mapGetters } from "vuex";
import api from "@/lib/api";
import ChatWindow from '@/components/ChatWindow.vue';
import Login from "@/components/ChatUI";
// Vue.component("login", Login);
export default {
  data() {
    return {
      showChatBox: false,
      chatWindow: 'ChatWindow',
      login:'Login'
    };
  },
  components: {
    ChatWindow,
    Login
  },
  computed: {
    ...mapGetters("user", ["isAuthenticated", "currentUser"]),
    dashboardUrl() {
      return this.isAuthenticated
        ? api.getHostDashboardUrl() +
            "/app/dashboard/menu?token=" +
            this.currentUser.token
        : api.getHostDashboardUrl();
      // return this.isAuthenticated ? "http://betadashboard.toolaku.com/account/login" : "http://betadashboard.toolaku.com/account/login"
    },
  },
  methods: {
    toggleComponent() {
      this.showChatBox = !this.showChatBox
    },

    unAuthenticated() {
      if (!this.isAuthenticated) {
        return "display: block;";
      } else {
        return "display: none;";
      }
    }

  }
  
};
</script>

<style>

.slow-enter-active,
.slow-leave-active {
  transition: opacity 0.3s ease;
}

.slow-enter,
.slow-leave-to {
  opacity: 0;
}

.icon{
  font-size:35px; 
  color:#fff;
}

.icon:active{
  transform: rotate(-270deg);
  transition: all 0.3s linear;
  opacity: 0;
}

.icon::after{
  opacity: 0;
  transition: all 1.3s linear;
}

.floating-button--container {
  position: fixed;
  bottom: 20px;
  right: 20px;
}

.floating-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #365462;
  border-radius: 50%;
  width: 70px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.5);

}

.floating-button:hover{
  transform: scale(1.1);
}

.chat-window{
  margin-bottom: 100px;
}

.chat-box {
  position: fixed;
  bottom: 100px;
  right: 20px;
  width: 300px;
  height: 400px;
  background-color: white;
  border: 2px solid black;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.5);
}
</style>



